import { Injectable } from '@angular/core';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  config: AuthConfig = {
    issuer: environment.issuer,
    redirectUri: environment.redirectUri,
    clientId: environment.clientId,
    responseType: "code",
    scope: "openid profile email address phone offline_access",
    disablePKCE: false,
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true
  };

  constructor(
    private oauthService: OAuthService,
    private httpService: HttpService,
  ) { }


  initSSOLogin() {
    this.oauthService.configure(this.config);
    this.oauthService.loadDiscoveryDocument().then((er) => {
      console.log(er);
    }).catch((err) => {
      console.log(err);
    });
  }

  SSOLogin() {
    try {
      this.oauthService.initCodeFlow();
    } catch (error) {
      console.log(error)
    }
  }

  adminSsoLogin(payload) {
    return this.httpService.apiPost('/auth/admin/sso', payload);
  }

  logOut() {
    this.httpService.localStorageClear();
    sessionStorage.clear();
    this.oauthService.logOut(true);
  }
}
